<template>
   <div class='stake-holders'>
      <process-header :step='2'/>
      <div class='step-title'>
         <span>Establish Energy Development Sub-Committee Team</span>
         <add-button @click="showCreateForm">
            Add Team
         </add-button>
      </div>
      <div style="overflow: auto;">
         <el-table :data="tableData">
            <el-table-column label="Actions" fixed>
               <template slot-scope="scope">
                  <el-button
                     @click="handleEdit(scope.$index, scope.row)"
                     size="mini"
                     icon="el-icon-edit"
                     style="margin: 3px;"
                     circle
                     content="Edit"
                     v-tippy
                  />
                  <el-button
                     @click="handleDelete(scope.$index, scope.row)"
                     size="mini"
                     icon="el-icon-delete"
                     content="Delete"
                     v-tippy
                     circle
                  />
               </template>
            </el-table-column>
            <el-table-column
               v-for="{label, prop, width} in tableColumns"
               :key="prop"
               :prop="prop"
               :width="width"
               :label="label"
            />
         </el-table>
      </div>
      <back-and-continue
         :back-route="{name: 'stakeholders'}"
         :next-route="{name: 'energy-baseline'}"
      />
      <common-dialog-form
         :visible="showForm"
         title="EDSC Information"
         @close="showForm=false"
         @submit="handleFormSubmit"
         >
         <input-field
            label="Name"
            placeholder="Name"
            type="text"
            v-model="form.name"
            :errors="errors.name"
            required
         />
         <input-field
            label="EDSC Designation"
            placeholder="EDSC Designation"
            type="select"
            v-model="form.edsc_designation"
            :options='[
               { title: "President", value: "President" },
               { title: "Secretary", value: "Secretary" },
               { title: "Member", value: "Member" },
               { title: "Patron", value: "Patron" },
               { title: "Advisor", value: "Advisor" },
            ]'
            :errors="errors.edsc_designation"
            required
         />
         <input-field
            label="Organization"
            placeholder="Organization"
            type="select"
            v-model="form.organization"
            :options='[
               { title: "Municipality", value: "Municipality" },
               { title: "School", value: "School" },
               { title: "Private Company", value: "Private Company" },
               { title: "Others", value: "Others" },
            ]'
            :errors="errors.organization"
            required
         />
         <input-field
            label="Organization Designation"
            placeholder="Organization Designation"
            type="select"
            v-model="form.org_destination"
            :options='[
               { title: "Mayor/Chairperson",            value: "Mayor/Chairperson" },
               { title: "Deputy/Vice Chairperson",      value: "Deputy/Vice Chairperson" },
               { title: "Chief Administrative Officer", value: "Chief Administrative Officer" },
               { title: "Ward Chairperson",             value: "Ward Chairperson" },
               { title: "Secretary",                    value: "Secretary" },
               { title: "Member",                       value: "Member" },
               { title: "Advisor",                      value: "Advisor" },
               { title: "Technical Expert",             value: "Technical Expert" },
               { title: "GESI Focal Person",            value: "GESI Focal Person" }, 
            ]'
            :errors="errors.org_destination"
            required
         />
         <input-field
            label="Contact No"
            placeholder="Contact No"
            type="text"
            v-model="form.contact_no"
            :errors="errors.contact_no"
            required
         />
      </common-dialog-form>
   </div>
</template>

<script>
import { Table, TableColumn, Button } from 'element-ui';
import ProcessHeader from "../Header";
import CommonDialogForm from '../../../../organisms/Home/CommonDialogForm';
import BackAndContinue from '../../../../molecules/Home/Plan/Back&Continue';
import AddButton from '../../../../molecules/Home/Plan/AddButton';
import InputField from '../../../../molecules/Login/InputField';
import { fetchWithAuthToken, postWithAuthToken } from '../../../../../axios';
import { hideLoading, showError, showLoading, confirm, showSuccess } from '../../../../../js/ui-helpers';
import {getDefaultErrors, updateProps} from '../../../../../js/form-helpers';

const tableColumns = [
   {label: 'Name', prop: "name", width: 100},
   {label: 'EDSC Designation', prop: "edsc_designation", width: 140},
   {label: 'Organization', prop: "organization", width: 110},
   {label: 'Organization Designation', prop: "org_destination", width: 190},
   {label: 'Contact No', prop: "contact_no", width: 100},
];

export default {
   name: "energy-sub-commitee",
   components: {
      ProcessHeader,
      InputField,
      CommonDialogForm,
      AddButton,
      BackAndContinue,
      'el-table': Table,
      'el-table-column': TableColumn,
      'el-button': Button,
   },
   data()
   {
      const form = {
         name: '',
         edsc_designation: '',
         organization: '',
         org_destination: '',
         contact_no: '',
      };
      const errors = getDefaultErrors(form);
      return {
         form,
         errors,
         showForm: false,
         tableColumns,
         tableData: [],
      };
   },
   computed: {
      planId() {
         return this.$route.params.id;
      },
   },
   async created()
   {
      try
      {
         showLoading('loading stakeholders');
         const response = await fetchWithAuthToken(`api/plan/${this.planId}/sub-commitee/`);
         this.tableData = response.data;
      }
      catch (error)
      {
         console.log(error);
      }
      hideLoading();
   },
   methods: {
      clearErrors()
      {
         return updateProps(this.errors, getDefaultErrors(this.form));
      },
      showCreateForm()
      {
         this.clearErrors();
         this.showForm = true,
         this.form = {
            id: null,
            name: '',
            edsc_designation: '',
            organization: '',
            org_destination: '',
            contact_no: '',
         };
      },
      handleEdit(index, row) {
         this.clearErrors();
         this.showForm = true;
         this.form = row;
      },
      handleDelete(index, row)
      {
         const deleteTeam = async () =>
         {
            try
            {
               const response = await postWithAuthToken(`/api/plan/${this.planId}/sub-commitee/${row.id}`, {}, {method: 'delete'})
               console.assert(response.status===204, `Invalid status code: ${response.status}`);
               this.tableData = this.tableData.filter(item => item.id!==row.id)
               showSuccess('Delete Sub-commitee Team', `Successfully deleted team (${row.name})`);
            }
            catch (error)
            {
               console.log(error);
               showError('Delete Sub-commitee Team', 'Error deleting team');
            }
         }
         confirm({ title: 'Delete Sub-commitee Team', onSuccess: deleteTeam });
      },
      async handleFormSubmit()
      {
         this.clearErrors();
         const isAddForm = this.form.id == null;
         try
         {
            const url = `/api/plan/${this.planId}/sub-commitee/${isAddForm ? '' : this.form.id}`;
            const method = isAddForm ? 'post' : 'put';
            const {data} = await postWithAuthToken(url, this.form, {method});
            if (isAddForm)
            {
               this.tableData.push(data);
            }
            const message = `Successfully ${isAddForm ? 'added a' : 'edited'} team`;
            showSuccess("Sub-commitee Team Form", message);
            this.showForm = false;
         }
         catch (error)
         {
            console.log(error);
            if (error.response && error.response.status===400 && error.response.data)
            {
               updateProps(this.errors, error.response.data)
            }
            const message = `Error ${isAddForm ? 'adding' : 'editing'} team`;
            showError("Sub-commitee Team Form", message);
         }
      },
  },
};
</script>

<style lang="scss" scoped>
.stake-holders {
   font-family: $primary-font;
   color: $font-color;

   .step-title {
      span {
         font-family: $secondary-font;
         font-weight: 500;
         font-size: 1.05em;
      }
      font-family: inherit;
      padding: .5em;
      display: flex;
      justify-content: space-between;
   }
   .btn-group {
      display: flex;
      margin: 0 0.3em;
      > * {
         margin-right: 0.3em;
         a {
            color:inherit;
         }
         &:last-child {
            margin-right: 0;
         }
      }
   }
}
</style>
